import { ReactNode } from "react";

export function ModuleColumn({
  headline,
  children,
  graphic,
  doubleWidth = false,
  doubleHeight = false,
  id,
  className,
}: {
  headline: ReactNode;
  children: ReactNode;
  graphic?: ReactNode;
  doubleWidth?: boolean;
  doubleHeight?: boolean;
  id?: string;
  className?: string;
}) {
  const layoutClassName = doubleWidth
    ? "double-width"
    : doubleHeight
    ? "double-height"
    : undefined;
  return (
    <section
      className={[layoutClassName, className].filter(Boolean).join(" ")}
      id={id}
    >
      <div
        className="padded-box"
        style={graphic ? { paddingBottom: 16 } : undefined}
      >
        <h3>{headline}</h3>
        {children}
      </div>
      {graphic}
      <style jsx>{`
        section {
          border-radius: var(--module-radius);
          background-color: var(--module-color);
          display: flex;
          flex-direction: column;
          max-width: calc(100vw - 24px);
          overflow: hidden;
          scroll-margin-top: 72px;
        }
        .padded-box :global(p) {
          max-width: 64ch;
        }
        .padded-box :global(p:last-of-type) {
          margin-bottom: 0;
        }
        @media (min-width: 820px) {
          section {
            scroll-margin-top: 140px;
          }
          .double-width {
            grid-column: span 2;
          }
          .double-height {
            grid-row: span 2;
          }
        }
      `}</style>
    </section>
  );
}

export function ModuleTwoUp({
  headline,
  children,
  graphic,
  id,
  className,
}: {
  headline: ReactNode;
  children: ReactNode;
  graphic?: ReactNode;
  id?: string;
  className?: string;
}) {
  return (
    <section id={id} className={className}>
      <div className="padded-box">
        <h3>{headline}</h3>
        {children}
      </div>
      {graphic}
      <style jsx>{`
        section {
          display: grid;
          border-radius: var(--module-radius);
          background-color: var(--module-color);
          overflow: hidden;
          scroll-margin-top: 72px;
        }

        @media (min-width: 820px) {
          section {
            grid-column: span 2;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            scroll-margin-top: 140px;
          }
        }
      `}</style>
    </section>
  );
}
